<template>
  <img
    v-if="src"
    class="UnicodeEmoji"
    :src="src"
    :alt="emoji"
    :title="title"
    draggable="false"
    loading="lazy"
    @error="onError"
  >
  <span
    v-else
    :title="title"
  >{{ emoji }}</span>
</template>

<script>
import { useMergedConfigStore } from 'src/stores/merged_config.js'

import {
  isUnicodeEmoji,
  unicodeEmojiUrls,
} from 'src/services/unicode_emoji/unicode_emoji.js'

// One unicode emoji: a Twemoji picture when the user asked for images,
// the character itself otherwise, or once every picture has failed.
export default {
  props: {
    emoji: { type: String, required: true },
    title: { type: String, default: undefined },
  },
  data() {
    return { failed: 0 }
  },
  computed: {
    src() {
      // reactions can carry a shortcode here; only an emoji has a picture
      if (!useMergedConfigStore().mergedConfig.emojiAsImages) return null
      if (!isUnicodeEmoji(this.emoji)) return null
      return unicodeEmojiUrls(this.emoji)[this.failed] ?? null
    },
  },
  watch: {
    emoji() {
      this.failed = 0
    },
  },
  methods: {
    onError() {
      this.failed += 1
    },
  },
}
</script>

<style lang="scss">
.UnicodeEmoji {
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  object-fit: contain;
}
</style>
